var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2174 6.36487C12.2174 6.75743 12.2485 7.08633 12.2032 7.40392C12.1841 7.53901 12.0264 7.68401 11.897 7.76535C11.2696 8.16357 10.5884 8.48187 10.0035 8.93879C8.1107 10.4185 6.9889 12.3665 6.92736 14.8972C6.91039 15.6152 7.17492 15.7955 7.77756 15.5147C9.51968 14.707 11.3934 15.1809 12.3928 16.6818C13.4828 18.3199 13.3293 20.5013 12.0229 21.9315C10.355 23.7578 7.60922 23.813 5.71573 22.0673C4.5819 21.0219 4.04292 19.6723 3.90853 18.1367C3.45797 12.9938 6.03756 8.75418 10.7334 6.89182C11.1981 6.70792 11.6742 6.55655 12.2174 6.36487Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5055 6.36487C22.5055 6.75743 22.5366 7.08633 22.4913 7.40392C22.4722 7.53901 22.3145 7.68401 22.1851 7.76535C21.5577 8.16357 20.8765 8.48187 20.2916 8.93879C18.3988 10.4185 17.277 12.3665 17.2154 14.8972C17.1985 15.6152 17.463 15.7955 18.0656 15.5147C19.8078 14.707 21.6814 15.1809 22.6809 16.6818C23.7709 18.3199 23.6174 20.5013 22.311 21.9315C20.6431 23.7578 17.8973 23.813 16.0038 22.0673C14.87 21.0219 14.331 19.6723 14.1966 18.1367C13.7461 12.9938 16.3256 8.75418 21.0215 6.89182C21.4862 6.70792 21.9623 6.55655 22.5055 6.36487Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenQuote);
export default __webpack_public_path__ + "static/media/open-quote.dab0a929026ec49731933a9576a24f6d.svg";
export { ForwardRef as ReactComponent };